// extracted by mini-css-extract-plugin
export default {"header":"BL-z","isActive":"CL-z"};